import Vue from 'vue'
import Vuex from 'vuex'
import api from './api'
import face from './interface'

Vue.use(Vuex)
Vue.prototype.$api = api
Vue.prototype.$face = face

const state = {
  allCustom: [],
  isLoadCustom: true, // 是否加载所有客户列表
  allRole: [],
  isLoadRole: true,
  labels: [],
  isLoadLabels: true,
  menus: [],
  isLoadMenus: true,
  userType: sessionStorage.getItem('userType'),
  statusColor: [
    { status: 1, color: 'green' },
    { status: 2, color: 'red' },
    { status: 7, color: 'red' },
    { status: 5, color: '#ddd' },
    { status: 6, color: '#333' }
  ]
}

const mutations = {
  setUserType (state) {
    state.userType = sessionStorage.getItem('userType')
  },
  setAllCustom (state, data) {
    state.allCustom = data
  },
  setLoadCustom (state, flag) {
    state.isLoadCustom = flag
  },
  setAllRole (state, data) {
    state.allRole = data
  },
  setLoadRole (state, flag) {
    state.isLoadRole = flag
  },
  setAllDics (state, data) {
    state.labels = data
  },
  setLoadDics (state, flag) {
    state.isLoadLabels = flag
  },
  setMenus (state, data) {
    state.menus = data
  },
  setLoadMenus (state, flag) {
    state.isLoadMenus = flag
  }
}

const actions = {
  // 获取所有的客户下拉
  getAllCustom ({ commit }) {
    if (state.isLoadCustom) {
      api.post(face.Other.allCustom, {}, function (r) {
        if (r.status) {
          commit('setAllCustom', r.list)
        }
        commit('setLoadCustom', false)
      })
    }
  },
  //  获取所有的角色下拉
  getAllRole ({ commit }) {
    if (state.isLoadRole) {
      api.post(face.Other.allRole, {}, function (r) {
        if (r.status) {
          commit('setAllRole', r.list)
        }
        commit('setLoadRole', false)
      })
    }
  },
  // 获取所有字典信息
  getAllDics ({ commit }) {
    if (state.isLoadLabels) {
      api.post(face.Other.allDics, {}, function (r) {
        if (r.status) {
          commit('setAllDics', r.list)
        }
        commit('setLoadDics', false)
      })
    }
  },
  // 获取所有菜单
  getAllMenus ({ commit }) {
    if (state.isLoadMenus) {
      api.post(face.SystemUrl.menuTree, {}, function (r) {
        if (r.status) {
          commit('setMenus', r.detail)
        }
        commit('setLoadMenus', false)
      })
    }
  }
}
export default new Vuex.Store({
  state,
  actions,
  mutations
})

// WEBPACK FOOTER //
// ./src/js/store.js



// WEBPACK FOOTER //
// ./src/js/store.js